export default __webpack_public_path__ + "static/media/Yenepoya.e0e27ec6.png";